import { createApp } from '@backstage/frontend-defaults';
import catalogPlugin from '@backstage/plugin-catalog/alpha';
import scaffolderPlugin from '@backstage/plugin-scaffolder/alpha';
import { navModule } from './modules/nav';
import { themeModule } from './modules/theme';
import { authModule } from './modules/auth';
import { homeModule } from './modules/home';
import { catalogMarkersModule } from './modules/catalogMarkers';
import { deliverySignalsModule } from './modules/deliverySignals';
import { controlPlaneAdminModule } from './modules/controlPlaneAdmin';
import { onboardingWizardModule } from './modules/onboardingWizard';

export default createApp({
  features: [
    catalogPlugin,
    scaffolderPlugin,
    navModule,
    themeModule,
    authModule,
    homeModule,
    catalogMarkersModule,
    deliverySignalsModule,
    controlPlaneAdminModule,
    onboardingWizardModule,
  ],
});
